import { module } from 'angular';
import App from '../../../app';

class SCR1602Controller {
	
	constructor ($scope, $state, $timeout, $uibModalInstance, httpService, utilService, gridService, popupService, data){
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModalInstance = $uibModalInstance;
		this.$timeout = $timeout;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.data = data;
		
		this.initWindow(720, 640);
		this.initText();
		this.initSearch();
		this.initSelect();
		
		this.$timeout(() => {
			this.setGridHeight();
			this.initInstCdGridOption();
			this.getExtrnlinstList();
		});
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = {
			instCdSearch : bxMsg('manageExtInstCode.instCdSearch'),
			instCd : bxMsg('manageExtInstCode.instCd'),
			instCdNm : bxMsg('manageExtInstCode.instCdNm'),
			instDstnctnVal : bxMsg('manageExtInstCode.instDstnctnVal'),
			instCdDesc : bxMsg('manageExtInstCode.instCdDesc'),
			select : bxMsg('common.select'),
			cancel : bxMsg('common.cancel'),
			search : bxMsg('common.search'),
			resetSearch : bxMsg('common.resetSearch')
		};
	}
	
	initSearch(){
		this.searchParam = {};
	}
	
	initSelect(){
		this.select = this.gridService.getSelect(10);
	}
	
	initInstCdGridOption(){
		this.gridView = new RealGridJS.GridView('grid');
		this.dataProvider = new RealGridJS.LocalDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setCheckBar({visible: false});
		this.gridView.setDisplayOptions({fitStyle: 'evenFill'}); 
		
		this.dataProvider.setFields([
            {
            	fieldName: "no",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.gridService.getNoField(this.select.pageSize, dataRow, this.pageNumber);
        		}
    		}, 
    		 {fieldName: "instCd"}, {fieldName: "instCdNm"}, {fieldName: "instDstnctnVal"}, {fieldName: "instCdDesc"}
        ]);
		
		this.gridView.setColumns([
			{ name: "no", fieldName: "no", header : { text: "no" } , width: 40, styles: { textAlignment: 'center' } },
			{ name: "instCd", fieldName: "instCd", header : { text: this.text.instCd }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "instCdNm", fieldName: "instCdNm", header : { text: this.text.instCdNm }, width: 100, styles: { textWrap: 'ellipse' } },
			{ name: "instDstnctnVal", fieldName: "instDstnctnVal", header : { text: this.text.instDstnctnVal }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "instCdDesc", fieldName: "instCdDesc", header : { text: this.text.instCdDesc }, width: 100, styles: { textWrap: 'ellipse' } }
		]);
		
		this.gridView.onDataCellDblClicked = (grid, cell) => {
			this.closeModal(true)
		};
	}
	
	getExtrnlinstList(goToFirst = false) {
		const {pageNumber, pageSize} = this.getPageInfo();
		let url = `/extrnlinsts?pageNumber=${ goToFirst ? 1 : pageNumber}&pageSize=${pageSize}`;
		
		this.httpService.get(url, this.searchParam).then(data => {
			if(goToFirst) {
				this.pageNumber = 1;
				this.$scope.$broadcast(`resetPage`, this.pageNumber);
			}
			
			this.recordsCount = data.totalCnt;
			this.dataProvider.setRows(data.extrnlinstcdOutList);
		});
	}
	
	getPageInfo() {
		return {
			pageNumber: this.pageNumber || 1,
			pageSize: this.select.pageSize
		};
	}
	
	resetSearch(){
		this.searchParam = {};
		this.getExtrnlinstList(true);
	}
	
	search(){
		this.getExtrnlinstList(true);
	}
	
	blur($event){
		$event.target.blur();
	}
	
	pageBtnClick(num){
		this.pageNumber = num;
		this.getExtrnlinstList(num === 1);
	}
	
	closeModal(isOk){
		if(isOk){
			const selection = this.gridView.getSelectedRows();
			
			if(selection.length === 0){
				this.$uibModalInstance.dismiss();
			} else {
				this.$uibModalInstance.close(this.gridView.getValues(selection[0]));
			}
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.gridView.destroy();
		this.dataProvider.destroy();
	}
	
	setGridHeight() {
		let $msgGrid = $('#grid');
		let height = this.gridService.getGridHeight(this.select.pageSize);
		
		$msgGrid.height(height);
	}
}

module(App.name).controller('SCR1602Controller', SCR1602Controller);


// WEBPACK FOOTER //
// ./src/app/views/popup/SCR1602/SCR1602.controller.js